import { render } from "./hintBox.vue?vue&type=template&id=a7ece5aa&scoped=true"
import script from "./hintBox.vue?vue&type=script&lang=js"
export * from "./hintBox.vue?vue&type=script&lang=js"

import "./hintBox.vue?vue&type=style&index=0&id=a7ece5aa&scoped=true&lang=css"

import exportComponent from "/Users/aiden/Desktop/hujian/hongyu/edu-web-mobile/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a7ece5aa"]])

export default __exports__